// ignore-string-externalization
var SET_STATE = 'SET_STATE';
export var setState = function setState(_ref) {
  var payload = _ref.payload,
      type = _ref.type;
  return {
    type: type,
    payload: payload,
    meta: {
      type: SET_STATE
    }
  };
};

var rootState = function rootState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.meta && action.meta.type === SET_STATE) {
    return Object.assign({}, state, action.payload);
  }

  return state;
};

export default rootState;